import { render, staticRenderFns } from "./HomePainel.vue?vue&type=template&id=0aff0fef&scoped=true"
import script from "./HomePainel.vue?vue&type=script&lang=js"
export * from "./HomePainel.vue?vue&type=script&lang=js"
import style0 from "./HomePainel.vue?vue&type=style&index=0&id=0aff0fef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aff0fef",
  null
  
)

export default component.exports